import { createHashRouter, redirect } from 'react-router-dom';
import React from 'react';
import {
  HomeScreen,
  LoginScreen,
  TrendsScreen,
  AlertsScreen,
  TariffRatesScreen,
} from 'screens';
import { RootLayout } from 'components';
import { getLocalToken } from '../utils/getLocalToken';

export const router = createHashRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        loader: (args) => {
          return redirect('/home');
        },
      },
      {
        path: '/home',
        element: <HomeScreen />,
      },
      {
        path: 'login',
        element: <LoginScreen onLoginSuccess={() => null} />,
        loader: (args) => {
          console.log('login verify token');
          // verify user
          if (getLocalToken()) return redirect('/');

          return null;
        },
      },
      {
        path: 'logout',
        // element: <div>logout</div>,
        loader: async () => {
          console.log('remove token and go to login');
          localStorage.removeItem('jwt');
          return redirect('/login');
        },
      },
      {
        path: 'trends',
        loader: (args) => {
          return redirect('/trends/day');
        },
      },
      {
        path: 'trends/:type',
        element: <TrendsScreen />,
      },
      {
        path: 'alerts',
        element: <AlertsScreen />,
      },
      {
        path: 'tariffs',
        element: <TariffRatesScreen />,
      },
    ],
  },
]);
